import { toJsxRuntime } from 'hast-util-to-jsx-runtime'
import { createElement, Fragment, ReactNode } from 'react';
import MarkdownLink, { MarkdownLinkProps } from '../contentful/callToActions/markdownLink';

const useHtmlAst = (htmlAst: any): React.ReactElement | null => {
  if (!htmlAst) return null;

  if (typeof htmlAst !== 'object') {
    console.warn('Invalid input AST type:', typeof htmlAst, htmlAst);
  }

  const { jsx, jsxs } = require('react/jsx-runtime');

  const options: any = {
    createElement,
    Fragment,
    components: {
      cta: MarkdownLink
    },
    jsx,
    jsxs,
    jsxRuntime: 'automatic',
    jsxImportSource: 'react'
  };

  try {
    return toJsxRuntime(htmlAst, options);
  } catch (error) {
    console.error('Error processing AST:', error);
    return null;
  }

};



export default useHtmlAst;
